import { useSetting } from "@faire/deprecated-retailer-visitor-shared/settings/__internal__/useSetting";
import { FAIRE_DIRECT_SIGNUP_PHASE_1_250704 } from "@faire/web-api--source/indigofair/settings/FAIRE_DIRECT_SIGNUP_PHASE_1_250704";
import { FAIRE_DIRECT_SIGNUP_PHASE_2_250705 } from "@faire/web-api--source/indigofair/settings/FAIRE_DIRECT_SIGNUP_PHASE_2_250705";

export const useSettingFaireDirectCreditForVisitorPhase1 = () => {
  return useSetting(FAIRE_DIRECT_SIGNUP_PHASE_1_250704, false);
};

export const useSettingFaireDirectCreditForVisitorPhase2 = () => {
  return useSetting(FAIRE_DIRECT_SIGNUP_PHASE_2_250705, false);
};
